import permission from './permission';
import qfeiTrim from './qfeiTrim';

export default {
  install(Vue) {
    Vue.directive('permission', permission);
    Vue.directive('qfeiTrim', qfeiTrim);
  }
};
